module.exports = __webpack_public_path__ + "static/media/shape0.pngfeat1.3d5f2a13.png";